import { InputCurrency, InputCurrencyGroup } from "@finanedi.es/storybook"
import { DeclaracionModelo303DtoProps } from "api/DTOs/DeclaracionModelo303Dto"
import { InputText } from "primereact/inputtext"
import { UseFormSetValue, UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import {
  calculateCasilla27CuotaDevengada,
  calculateCasilla45TotalDeducir,
  calculateCasilla46ResultadoRegimenGeneral,
} from "../constants"

const LiquidacionModelo303 = ({
  setValue,
  watch,
}: {
  setValue: UseFormSetValue<DeclaracionModelo303DtoProps>
  watch: UseFormWatch<DeclaracionModelo303DtoProps>
}) => {
  const { t } = useTranslation()

  const values = watch()
  return (
    <div className='tw-w-full tw-h-full tw-flex tw-flex-col'>
      <div className='tw-w-full tw-h-fit tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-t tw-border-neutral-25 tw-px-6 tw-min-h-10'>
        <span className='tw-text-sm tw-font-medium'>
          {t("taxSummary.declaracion.liquidacionModelo.box1")}
        </span>
      </div>
      <div className='tw-w-full tw-h-fit tw-border-b tw-border-neutral-25 tw-px-6 tw-grid tw-grid-cols-5 tw-gap-x-3 tw-gap-y-1 tw-py-1'>
        <span className='tw-text-sm tw-text-left tw-col-span-2 tw-row-span-6 tw-flex tw-items-center tw-justify-start'>
          {t("taxSummary.declaracion.liquidacionModelo.box2")}
        </span>

        <div className='tw-flex tw-flex-col'>
          <span className='tw-text-xs tw-text-left tw-font-medium'>
            {t("taxSummary.declaracion.liquidacionModelo.box2titleOne")}
          </span>
          <InputCurrencyGroup
            suffix='€'
            value={values.dp30301?.casilla150}
            placeholder='0,00'
            className='tw-h-full'
            numberGroup='150'
            onChange={(value: number | undefined) =>
              setValue("dp30301.casilla150", value || 0)
            }
          />
        </div>
        <div className='tw-flex tw-flex-col'>
          <span className='tw-text-xs tw-text-left tw-font-medium'>
            {t("taxSummary.declaracion.liquidacionModelo.box2titleTwo")}
          </span>
          <InputCurrencyGroup
            suffix='%'
            disabled
            value={0}
            className='tw-h-full'
            numberGroup='151'
          />
        </div>
        <div className='tw-flex tw-flex-col'>
          <span className='tw-text-xs tw-text-left tw-font-medium'>
            {t("taxSummary.declaracion.liquidacionModelo.box3titleOne")}
          </span>
          <InputCurrencyGroup
            suffix='€'
            value={values.dp30301?.casilla152}
            placeholder='0,00'
            className='tw-h-full'
            numberGroup='152'
            onChange={(value: number | undefined) => {
              setValue("dp30301.casilla152", value || 0)
            }}
          />
        </div>
        <InputCurrencyGroup
          suffix='€'
          placeholder='-'
          className='tw-h-full'
          numberGroup='165'
          disabled
        />
        <InputCurrencyGroup
          suffix='%'
          disabled
          placeholder='-'
          className='tw-h-full'
          numberGroup='166'
        />
        <InputCurrencyGroup
          suffix='€'
          placeholder='-'
          className='tw-h-full'
          numberGroup='167'
          disabled
        />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla01}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='01'
          onChange={(value: number | undefined) => {
            setValue("dp30301.casilla01", value || 0)
            setValue("dp30301.casilla03", (value || 0) * 0.04)
          }}
        />
        <InputCurrencyGroup
          suffix='%'
          value={4}
          disabled
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='02'
        />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla03}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='03'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla03", value || 0)
          }
        />
        <InputCurrencyGroup
          suffix='€'
          placeholder='-'
          className='tw-h-full'
          numberGroup='153'
          disabled
        />
        <InputCurrencyGroup
          suffix='%'
          disabled
          placeholder='-'
          className='tw-h-full'
          numberGroup='154'
        />
        <InputCurrencyGroup
          suffix='€'
          placeholder='-'
          className='tw-h-full'
          numberGroup='155'
          disabled
        />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla04}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='04'
          onChange={(value: number | undefined) => {
            setValue("dp30301.casilla04", value || 0)
            setValue("dp30301.casilla06", (value || 0) * 0.1)
          }}
        />
        <InputCurrencyGroup
          suffix='%'
          value={10}
          disabled
          className='tw-h-full'
          numberGroup='05'
        />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla06}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='06'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla06", value || 0)
          }
        />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla07}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='07'
          onChange={(value: number | undefined) => {
            setValue("dp30301.casilla07", value || 0)
            setValue("dp30301.casilla09", (value || 0) * 0.21)
          }}
        />
        <InputCurrencyGroup
          suffix='%'
          value={21}
          className='tw-h-full'
          numberGroup='08'
          disabled
        />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla09}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='09'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla09", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-border-b tw-border-neutral-25 tw-px-6 tw-gap-3 tw-py-1'>
        <span className='tw-text-sm tw-col-span-2 tw-text-left tw-flex tw-items-center tw-justify-start'>
          {t("taxSummary.declaracion.liquidacionModelo.box3")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla10}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='10'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla10", value || 0)
          }
        />
        <div />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla11}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='11'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla11", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-border-b tw-border-neutral-25 tw-px-6 tw-gap-3 tw-py-1'>
        <span className='tw-text-sm tw-col-span-2 tw-text-left tw-flex tw-items-center tw-justify-start'>
          {t("taxSummary.declaracion.liquidacionModelo.box4")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla12}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='12'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla12", value || 0)
          }
        />
        <div />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla13}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='13'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla13", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-border-b tw-border-neutral-25 tw-px-6 tw-gap-3 tw-py-1'>
        <span className='tw-text-sm tw-col-span-2 tw-text-left tw-flex tw-items-center tw-justify-start'>
          {t("taxSummary.declaracion.liquidacionModelo.box5")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla14}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='14'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla14", value || 0)
          }
        />
        <div />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla15}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='15'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla15", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-border-b tw-border-neutral-25 tw-px-6 tw-grid tw-grid-cols-5 tw-gap-x-3 tw-gap-y-1 tw-py-1'>
        <span className='tw-text-sm tw-col-span-2 tw-row-span-5 tw-text-left tw-flex tw-items-center tw-justify-start'>
          {t("taxSummary.declaracion.liquidacionModelo.box6")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla156}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='156'
          onChange={(value: number | undefined) => {
            setValue("dp30301.casilla156", value || 0)
            setValue("dp30301.casilla158", (value || 0) * 0.0175)
          }}
        />
        <InputCurrencyGroup
          suffix='%'
          value={1.75}
          className='tw-h-full'
          numberGroup='157'
          disabled
        />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla158}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='158'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla158", value || 0)
          }
        />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla168}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='168'
          onChange={(value: number | undefined) => {
            setValue("dp30301.casilla168", value || 0)
            setValue("dp30301.casilla170", (value || 0) * 0.005)
          }}
        />
        <InputCurrencyGroup
          suffix='%'
          value={0.5}
          className='tw-h-full'
          numberGroup='169'
          disabled
        />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla170}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='170'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla170", value || 0)
          }
        />
        <InputCurrencyGroup
          suffix='€'
          placeholder='-'
          className='tw-h-full'
          numberGroup='16'
          disabled
        />
        <InputCurrencyGroup
          suffix='%'
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='17'
          disabled
        />
        <InputCurrencyGroup
          suffix='€'
          placeholder='-'
          className='tw-h-full'
          numberGroup='18'
          disabled
        />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla19}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='19'
          onChange={(value: number | undefined) => {
            setValue("dp30301.casilla19", value || 0)
            setValue("dp30301.casilla21", (value || 0) * 0.014)
          }}
        />
        <InputCurrencyGroup
          suffix='%'
          value={1.4}
          className='tw-h-full'
          numberGroup='20'
          disabled
        />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla21}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='21'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla21", value || 0)
          }
        />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla22}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='22'
          onChange={(value: number | undefined) => {
            setValue("dp30301.casilla22", value || 0)
            setValue("dp30301.casilla24", (value || 0) * 0.052)
          }}
        />
        <InputCurrencyGroup
          suffix='%'
          value={5.2}
          className='tw-h-full'
          numberGroup='23'
          disabled
        />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla24}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='24'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla24", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 tw-py-1'>
        <span className='tw-text-sm tw-col-span-2 tw-text-left tw-flex tw-items-center tw-justify-start'>
          {t("taxSummary.declaracion.liquidacionModelo.box7")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla25}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='25'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla25", value || 0)
          }
        />
        <div />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla26}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='26'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla26", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-border-b tw-gap-3 tw-border-neutral-25 tw-px-6 tw-py-1'>
        <span className='tw-text-sm tw-col-span-4 tw-text-left tw-font-medium tw-flex tw-items-center tw-justify-start'>
          {t("taxSummary.declaracion.liquidacionModelo.box8")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={calculateCasilla27CuotaDevengada(values)}
          disabled
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='27'
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-10'>
        <span className='tw-text-sm tw-font-medium'>
          {t("taxSummary.declaracion.liquidacionModelo.box9")}
        </span>
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 tw-py-1'>
        <span className='tw-text-sm tw-col-span-3 tw-text-left tw-flex tw-items-center tw-justify-start'>
          {t("taxSummary.declaracion.liquidacionModelo.box10")}
        </span>
        <div className='tw-flex tw-flex-col'>
          <span className='tw-text-xs tw-text-left tw-font-medium'>
            {t("taxSummary.declaracion.liquidacionModelo.box10titleOne")}
          </span>
          <InputCurrencyGroup
            suffix='€'
            value={values.dp30301?.casilla28}
            placeholder='0,00'
            className='tw-h-full'
            numberGroup='28'
            onChange={(value: number | undefined) =>
              setValue("dp30301.casilla28", value || 0)
            }
          />
        </div>
        <div className='tw-flex tw-flex-col'>
          <span className='tw-text-xs tw-text-left tw-font-medium'>
            {t("taxSummary.declaracion.liquidacionModelo.box10titleTwo")}
          </span>
          <InputCurrencyGroup
            suffix='€'
            value={values.dp30301?.casilla29}
            placeholder='0,00'
            className='tw-h-full'
            numberGroup='29'
            onChange={(value: number | undefined) =>
              setValue("dp30301.casilla29", value || 0)
            }
          />
        </div>
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-gap-3 tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-col-span-3 tw-text-left tw-flex tw-items-center tw-justify-start'>
          {t("taxSummary.declaracion.liquidacionModelo.box11")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla30}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='30'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla30", value || 0)
          }
        />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla31}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='31'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla31", value || 0)
          }
        />
      </div>

      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-gap-3 tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-col-span-3 tw-text-left tw-flex tw-items-center tw-justify-start'>
          {t("taxSummary.declaracion.liquidacionModelo.box12")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla32}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='32'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla32", value || 0)
          }
        />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla33}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='33'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla33", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-gap-3 tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-col-span-3 tw-text-left tw-flex tw-items-center tw-justify-start'>
          {t("taxSummary.declaracion.liquidacionModelo.box13")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla34}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='34'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla34", value || 0)
          }
        />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla35}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='35'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla35", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-gap-3 tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-col-span-3 tw-text-left tw-flex tw-items-center tw-justify-start'>
          {t("taxSummary.declaracion.liquidacionModelo.box14")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla36}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='36'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla36", value || 0)
          }
        />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla37}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='37'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla37", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-gap-3 tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-col-span-3 tw-text-left tw-flex tw-items-center tw-justify-start'>
          {t("taxSummary.declaracion.liquidacionModelo.box15")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla38}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='38'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla38", value || 0)
          }
        />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla39}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='39'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla39", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-gap-3 tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-col-span-3 tw-text-left tw-flex tw-items-center tw-justify-start'>
          {t("taxSummary.declaracion.liquidacionModelo.box16")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla40}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='40'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla40", value || 0)
          }
        />
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla41}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='41'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla41", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-gap-3 tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-col-span-4 tw-text-left tw-flex tw-items-center tw-justify-start'>
          {t("taxSummary.declaracion.liquidacionModelo.box17")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla42}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='42'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla42", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-gap-3 tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-col-span-4 tw-text-left tw-flex tw-items-center tw-justify-start'>
          {t("taxSummary.declaracion.liquidacionModelo.box18")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla43}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='43'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla43", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-gap-3 tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-col-span-4 tw-text-left tw-flex tw-items-center tw-justify-start'>
          {t("taxSummary.declaracion.liquidacionModelo.box19")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={values.dp30301?.casilla44}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='44'
          onChange={(value: number | undefined) =>
            setValue("dp30301.casilla44", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-gap-3 tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-col-span-4 tw-text-left tw-font-medium tw-flex tw-items-center tw-justify-start'>
          {t("taxSummary.declaracion.liquidacionModelo.box20")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={calculateCasilla45TotalDeducir(values)}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='45'
          disabled
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-10'>
        <span className='tw-text-sm tw-font-medium'>
          {t("taxSummary.declaracion.liquidacionModelo.box21")}
        </span>
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-col-span-4 tw-text-left tw-font-medium tw-flex tw-items-center tw-justify-start'>
          {t("taxSummary.declaracion.liquidacionModelo.box22")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={calculateCasilla46ResultadoRegimenGeneral(values)}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='46'
          disabled
        />
      </div>
      {values.dp30301?.regimenSimple && (
        <div className='tw-flex tw-flex-col tw-w-full'>
          <div className='tw-w-full tw-h-fit tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-t tw-border-neutral-25 tw-px-6 tw-min-h-10'>
            <span className='tw-text-sm tw-font-medium'>
              {t("taxSummary.declaracion.liquidacionModelo.box23")}
            </span>
          </div>
          <div className='tw-w-full tw-h-fit tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-10'>
            <span className='tw-text-sm tw-font-medium'>
              {t("taxSummary.declaracion.liquidacionModelo.box24")}
            </span>
          </div>
          <div className='tw-w-full tw-h-fit tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-10'>
            <span className='tw-text-sm tw-font-medium'>
              {t("taxSummary.declaracion.liquidacionModelo.box25")}
            </span>
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-4 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <span className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box26titleOne")}
              </span>
              <InputText value='codigo' />
            </div>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <span className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box26titleTwo")}
              </span>
              <InputText value='vol ingresos' />
            </div>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <span className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box26titleThere")}
              </span>
              <InputText value='ind cuota' />
            </div>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <span className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box26titleFour")}
              </span>
              <InputText value='cuo devengada' />
            </div>
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-4 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <span className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box27titleOne")}
              </span>
              <InputCurrencyGroup
                suffix='€'
                value={0}
                placeholder='0,00'
                className='tw-h-full'
                numberGroup='1T,2T,3T'
              />
            </div>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <span className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box27titleTwo")}
              </span>
              <InputCurrencyGroup
                suffix='€'
                value={0}
                placeholder='0,00'
                className='tw-h-full'
                numberGroup='A'
              />
            </div>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <span className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box27titleThere")}
              </span>
              <InputCurrencyGroup
                suffix='€'
                value={0}
                placeholder='0,00'
                className='tw-h-full'
                numberGroup='4T'
              />
            </div>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <span className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box27titleFour")}
              </span>
              <InputCurrencyGroup
                suffix='€'
                value={0}
                placeholder='0,00'
                className='tw-h-full'
                numberGroup='B'
              />
            </div>
          </div>
          <div className='tw-w-full tw-h-fit tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-10'>
            <span className='tw-text-sm tw-font-medium'>
              {t("taxSummary.declaracion.liquidacionModelo.box27")}
            </span>
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-4 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <span className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box26titleOne")}
              </span>
              <InputText value='codigo' />
            </div>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <span className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box26titleTwo")}
              </span>
              <InputText value='vol ingresos' />
            </div>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <span className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box26titleThere")}
              </span>
              <InputText value='ind cuota' />
            </div>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <span className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box26titleFour")}
              </span>
              <InputText value='cuo devengada' />
            </div>
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-4 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <span className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box27titleOne")}
              </span>
              <InputCurrencyGroup
                suffix='€'
                value={0}
                placeholder='0,00'
                className='tw-h-full'
                numberGroup='1T,2T,3T'
              />
            </div>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <span className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box27titleTwo")}
              </span>
              <InputCurrencyGroup
                suffix='€'
                value={0}
                placeholder='0,00'
                className='tw-h-full'
                numberGroup='A'
              />
            </div>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <span className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box27titleThere")}
              </span>
              <InputCurrencyGroup
                suffix='€'
                value={0}
                placeholder='0,00'
                className='tw-h-full'
                numberGroup='4T'
              />
            </div>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <span className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box27titleFour")}
              </span>
              <InputCurrencyGroup
                suffix='€'
                value={0}
                placeholder='0,00'
                className='tw-h-full'
                numberGroup='B'
              />
            </div>
          </div>
          <div className='tw-w-full tw-h-fit tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-10'>
            <span className='tw-text-sm tw-font-medium'>
              {t("taxSummary.declaracion.liquidacionModelo.box28")}
            </span>
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4 tw-font-medium'>
              {t("taxSummary.declaracion.liquidacionModelo.box29")}
            </span>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <div className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box30")}
              </div>
              <InputText value='epigrafe' />
            </div>
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-3'>
              {t("taxSummary.declaracion.liquidacionModelo.box31")}
            </span>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <div className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box31titleOne")}
              </div>
              <InputCurrency
                value={0}
                placeholder='0,00'
                className='tw-h-full'
                suffix='ud'
              />
            </div>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <div className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box31titleTwo")}
              </div>
              <InputCurrency
                value={0}
                placeholder='0,00'
                className='tw-h-full'
                suffix='€'
              />
            </div>
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-3'>
              {t("taxSummary.declaracion.liquidacionModelo.box31")}
            </span>
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='ud'
            />
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-3'>
              {t("taxSummary.declaracion.liquidacionModelo.box31")}
            </span>
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='ud'
            />
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-3'>
              {t("taxSummary.declaracion.liquidacionModelo.box31")}
            </span>
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='ud'
            />
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-3'>
              {t("taxSummary.declaracion.liquidacionModelo.box31")}
            </span>
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='ud'
            />
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-3'>
              {t("taxSummary.declaracion.liquidacionModelo.box31")}
            </span>
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='ud'
            />
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-3'>
              {t("taxSummary.declaracion.liquidacionModelo.box31")}
            </span>
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='ud'
            />
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box32")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='C'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box33")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='D'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-10'>
            <span className='tw-text-sm tw-font-medium'>
              {t("taxSummary.declaracion.liquidacionModelo.box34")}
            </span>
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box35")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='Z'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box36")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='E'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box37")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='F'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-10'>
            <span className='tw-text-sm tw-font-medium'>
              {t("taxSummary.declaracion.liquidacionModelo.box38")}
            </span>
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box39")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='G'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box40")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='H'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box41")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='I'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box42")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='J'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box43")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='K'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box44")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='L'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box45")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='M'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4 tw-font-medium'>
              {t("taxSummary.declaracion.liquidacionModelo.box46")}
            </span>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <div className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box30")}
              </div>
              <InputText value='epigrafe' />
            </div>
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-3'>
              {t("taxSummary.declaracion.liquidacionModelo.box31")}
            </span>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <div className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box31titleOne")}
              </div>
              <InputCurrency
                value={0}
                placeholder='0,00'
                className='tw-h-full'
                suffix='ud'
              />
            </div>
            <div className='tw-flex tw-flex-col tw-w-full'>
              <div className='tw-text-xs tw-font-medium tw-text-left'>
                {t("taxSummary.declaracion.liquidacionModelo.box31titleTwo")}
              </div>
              <InputCurrency
                value={0}
                placeholder='0,00'
                className='tw-h-full'
                suffix='€'
              />
            </div>
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-3'>
              {t("taxSummary.declaracion.liquidacionModelo.box31")}
            </span>
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='ud'
            />
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-3'>
              {t("taxSummary.declaracion.liquidacionModelo.box31")}
            </span>
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='ud'
            />
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-3'>
              {t("taxSummary.declaracion.liquidacionModelo.box31")}
            </span>
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='ud'
            />
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-3'>
              {t("taxSummary.declaracion.liquidacionModelo.box31")}
            </span>
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='ud'
            />
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-3'>
              {t("taxSummary.declaracion.liquidacionModelo.box31")}
            </span>
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='ud'
            />
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-3'>
              {t("taxSummary.declaracion.liquidacionModelo.box31")}
            </span>
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='ud'
            />
            <InputCurrency
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box32")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='C'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box33")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='D'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-10'>
            <span className='tw-text-sm tw-font-medium'>
              {t("taxSummary.declaracion.liquidacionModelo.box34")}
            </span>
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box35")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='Z'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box36")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='E'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box37")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='F'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-10'>
            <span className='tw-text-sm tw-font-medium'>
              {t("taxSummary.declaracion.liquidacionModelo.box38")}
            </span>
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box39")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='G'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box40")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='H'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box41")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='I'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box42")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='J'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box43")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='K'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box44")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='L'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box45")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='M'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-10'>
            <span className='tw-text-sm tw-font-medium'>
              {t("taxSummary.declaracion.liquidacionModelo.box47")}
            </span>
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box48")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='51'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box49")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='52'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box50")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='53'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box51")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='54'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-10'>
            <span className='tw-text-sm tw-font-medium'>
              {t("taxSummary.declaracion.liquidacionModelo.box52")}
            </span>
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box53")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='55'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
              {t("taxSummary.declaracion.liquidacionModelo.box54")}
            </span>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='56'
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <div className='tw-text-left tw-flex tw-flex-col tw-justify-center tw-items-start tw-col-span-4'>
              <span className='tw-text-sm'>
                {t("taxSummary.declaracion.liquidacionModelo.box55")}
              </span>
              <span className='tw-text-xs tw-font-medium'>
                {t("taxSummary.declaracion.liquidacionModelo.box55Label")}
              </span>
            </div>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='57'
              disabled
              suffix='€'
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
            <div className='tw-text-left tw-flex tw-flex-col tw-justify-center tw-items-start tw-col-span-4'>
              <span className='tw-text-sm'>
                {t("taxSummary.declaracion.liquidacionModelo.box56")}
              </span>
              <span className='tw-text-xs tw-font-medium'>
                {t("taxSummary.declaracion.liquidacionModelo.box56Label")}
              </span>
            </div>
            <InputCurrencyGroup
              value={0}
              placeholder='0,00'
              className='tw-h-full'
              numberGroup='58'
              disabled
              suffix='€'
            />
          </div>
        </div>
      )}
      <span className='tw-text-xs tw-text-right tw-w-full tw-py-1 tw-px-6'>
        {t("taxSummary.declaracion.infoMsg")}
      </span>
    </div>
  )
}

export default LiquidacionModelo303
